var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page-wrap full-page" }, [
    _c(
      "div",
      { staticClass: "page-content" },
      [
        _c("nuxt-link", { attrs: { to: "/" } }, [
          _c("img", {
            staticClass: "logo",
            attrs: { src: require("assets/images/LassoLogoColor.png") }
          })
        ]),
        _vm._v(" "),
        _c("nuxt")
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }